interface StatChipInlineProps {
  n: number;
  label: string;
}

/** Single-line stat chip for compact download table chrome. */
export function StatChipInline({ n, label }: StatChipInlineProps) {
  return (
    <span className="stat-chip-inline">
      <span className="stat-chip-inline-n tabular-nums">{n}</span>
      <span className="stat-chip-inline-label">{label}</span>
    </span>
  );
}
